import React from "react";
import { connect } from "react-redux";
import HeaderPlan from "./HeaderPlan/view";
import { loadEtapas, crearPlanMovilidad } from "./actions";
import Loading from "../Util/Loading";

// etapas
import Sensibilizacion from "./Sensibilizacion/view";
import Diagnostico from "./Diagnostico/view";
import MiPlanMovilidad from "./PlanMovilidad/view";
import Seguimiento from "./Seguimiento/view";
import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../helpers/rolAccess";
import { paths } from "../../../config/routes";


class PlanesMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadEtapas();
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  }

  loadEtapas = () => {
    const tabs = [
      { text: "Sensibilización", contentId: 0 },
      { text: "Diagnóstico", contentId: 1 },
      { text: "Plan de acción", contentId: 2 },
      { text: "Ejecución y seguimiento", contentId: 3 },
    ];
    this.props.dispatch(loadEtapas(tabs, this.props.estadoProceso - 1));
  }

  renderBody = () => {
    switch (this.props.etapaPosition) {
      case 0: {
        return (<Sensibilizacion />);
      }
      case 1: {
        return (<Diagnostico />);
      }
      case 2: {
        return (<MiPlanMovilidad />);
      }
      case 3: {
        return (<Seguimiento />);
      }
      default:
        return <div />;
    }
  }

  render() {
    return (
      <div>

        <HeaderPlan />
        {
          (this.props.sucursalId !== "") ?
            <div>
              { this.props.isLoading && <Loading /> }
              <div>
                {
                  (this.props.estadoProceso === 0) ?

                    <section id="content-etapa">
                      <div className="btn-box">
                        <div className="row">
                          <div className="col-md-12 text-center PM-plan-contador-finalizar">
                            <div className="PM-home-item_plan">
                              <button
                                type="button"
                                className="btn PM-dx-button-plan PM-dx-button-plan-100"
                                onClick={() => { this.props.dispatch(crearPlanMovilidad(this.props.companyId, this.props.companyName, this.props.sucursalId, this.props.sucursalName, this.props.usuarioRUT, this.props.usuarioNombre, this.props.usuarioApellido, this.props.usuarioEmail)); }}
                              > Crear Plan de Movilidad
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>

                    :
                    <React.Fragment>
                      {this.renderBody()}
                    </React.Fragment>
                }
              </div>
            </div>
            :
            <div className="row">
              <div className="col-md-12 text-center">
                <h5>Selecciona un centro de trabajo para acceder a la opción de planes de movilidad.</h5>
              </div>
            </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  etapaPosition: state.planMovilidad.etapaPosition,
  estadoProceso: state.planMovilidad.estadoProceso,
  isLoading: state.planMovilidad.isLoading,
  sucursalId: state.global.sucursalId,
  sucursalName: state.global.sucursalName,
  companyId: state.global.companyId,
  companyName: state.global.companyName,
  usuarioRUT: state.global.userData.RUT,
  usuarioNombre: state.global.userData.FirstName,
  usuarioApellido: state.global.userData.LastName,
  usuarioEmail: state.global.userData.Email,
  userAccessIds: state.global.userAccessIds,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(PlanesMovilidad);
